import React, { Component } from 'react'
import FlatButton from 'material-ui/FlatButton'
import Dialog from 'material-ui/Dialog'
import api from '../../../api'
import store from '../../../store'
import { getDisplayName } from '../../../componentHelpers'
import { setSnackbarMessage } from '../../../actions/snackbar'

const withFileExport = WrappedComponent => {
  class ComponentWithFileExport extends Component<any, any> {
    constructor (props) {
      super(props)
      this.state = {
        download: null,
        error: null,
        isDialogOpen: false,
        isExporting: false
      }
      this.closeDialog = this.closeDialog.bind(this)
      this.handleExport = this.handleExport.bind(this)
    }

    closeDialog () {
      this.setState({ isDialogOpen: false })
    }

    handleExport (path) {
      this.setState({
        download: null,
        error: null,
        isDialogOpen: false,
        isExporting: true
      })
      return api
        .get(path)
        .then(res => {
          if (res.status === 400) {
            return res.json().then(error => {
              this.setState({ error, isExporting: false })
              store.dispatch(setSnackbarMessage('Could not export invoice'))
            })
          }
          return res.json().then(body => {
            this.setState({
              download: body,
              isDialogOpen: true,
              isExporting: false
            })
          })
        })
        .catch(() => {
          this.setState({
            isExporting: false
          })
        })
    }

    render () {
      const { download, error, isDialogOpen, isExporting } = this.state
      return (
        <div>
          <WrappedComponent
            {...this.props}
            exportError={error}
            isExporting={isExporting}
            requestExport={this.handleExport}
          />
          {download && isDialogOpen && (
            <Dialog
              title='Download Exported File'
              modal={false}
              open
              actions={[
                <FlatButton
                  label='Close'
                  primary
                  onClick={this.closeDialog}
                />
              ]}
              onRequestClose={this.closeDialog}
            >
              <a href={download.url}>{download.filename}</a>
            </Dialog>
          )}
        </div>
      )
    }
  }

// @ts-ignore
  ComponentWithFileExport.displayName = `WithFileExport(${getDisplayName(
    WrappedComponent
  )})`

  return ComponentWithFileExport
}

export default withFileExport
